import React from 'react';
import RouterGuard from '@/components/RouterGuard'
import type { Route } from '@/types/common'


const Guild = React.lazy(() => import('@/pages/Guild'))
const GuildMiddle = React.lazy(() => import('@/pages/Guild/middle'))
const GuildList = React.lazy(() => import('@/pages/Guild/list'))
const MemberApply = React.lazy(() => import('@/pages/Guild/apply'))
const Member = React.lazy(() => import('@/pages/Guild/member'))
const Invite = React.lazy(() => import('@/pages/Guild/invite'))
const Create = React.lazy(() => import('@/pages/Guild/create'))
const ConsoleDom = React.lazy(() => import('@/pages/Guild/console'))
const BindAngencyList = React.lazy(() => import('@/pages/Guild/bindList')) // 外管、BD绑定公会列表
const BdMember = React.lazy(() => import('@/pages/Guild/bdMember')) // BD成员
const ApplyGuild = React.lazy(() => import('@/pages/Guild/applyGuild')) // 公会创建申请列表
const ExtAdmins = React.lazy(() => import('@/pages/Guild/extAdmins')) // 外管列表
const DataCenter = React.lazy(() => import('@/pages/Guild/DataCenter'))
const DataDetail = React.lazy(() => import('@/pages/Guild/DataCenter/dataDetail'))
const PersonalCenter = React.lazy(() => import('@/pages/Guild/personalCenter')) // 个人中心
const ExtAdminMember = React.lazy(() => import('@/pages/Guild/extAdminMember')) // 外管成员列表

const guildRoutes: Route[] = [
  {
    path: '/guild/middle',
    name: 'GuildMiddle',
    title: '公会中间页',
    element: (<RouterGuard><GuildMiddle /></RouterGuard>),
  },
  {
    path: '/guild',
    name: 'Guild',
    title: '公会主页',
    element: (<Guild />),
  },
  {
    path: '/guild/list',
    name: 'GuildList',
    title: '公会列表',
    element: (<GuildList />),
  },
  {
    path: '/guild/apply',
    name: 'GuildApply',
    title: '申请加入公会列表',
    element: (<MemberApply />),
  },
  {
    path: '/guild/member',
    name: 'GuildMember',
    title: '成员列表',
    element: (<Member />),
  },
  {
    path: '/guild/invite',
    name: 'GuildInvite',
    title: '邀请粉丝',
    element: (<Invite />),
  },
  {
    path: '/guild/create',
    name: 'GuildCreate',
    title: '创建公会',
    element: (<Create />),
  },
  {
    path: '/guild/console',
    name: 'GuildConsole',
    title: '公会控制台',
    element: (<ConsoleDom />),
  },
  {
    path: '/guild/bind-list',
    name: 'BindAngencyList',
    title: '绑定公会列表',
    element: (<BindAngencyList />),
  },
  {
    path: '/guild/bd-member',
    name: 'BdMember',
    title: 'BD成员',
    element: (<BdMember />),
  },
  {
    path: '/guild/apply-guild',
    name: 'ApplyGuild',
    title: '公会创建申请列表',
    element: (<ApplyGuild />),
  },
  {
    path: '/guild/ext-admins',
    name: 'ExtAdmins',
    title: '外管列表',
    element: (<ExtAdmins />),
  },
  {
    path: '/guild/data-center',
    name: 'GuildDataCenter',
    title: '数据中心',
    element: (<DataCenter />),
  },
  {
    path: '/guild/data-center/detail',
    name: 'GuildDataDetail',
    title: '数据详情',
    element: (<DataDetail />),
  },
  {
    path: '/guild/personal-center',
    name: 'guildPersonalCenter',
    title: '个人数据中心',
    element: (<PersonalCenter />),
  },
  {
    path: '/guild/ext-admin-member',
    name: 'ExtAdminMember',
    title: '外管成员列表',
    element: (<ExtAdminMember />),
  }
]

export default guildRoutes;